import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import cx from "classnames";
import { getFormValues, getFormSyncErrors } from "redux-form";
import { withTranslation } from "react-i18next";
import Loader from "components/Loader/index";

import GridWrapper from "custom-hooks/GridWrapper";
import { setApi } from "reducers/grid";
import Diagram from "pages/Ordering/common/Diagram";

import AttributesFiltersForm from "../../../../pages/Ordering/common/AttributesFiltersForm";
import { configureFilterObject } from "../../../../pages/Ordering/common/util/configureFilterObject";
import useDebounce from "../../../../custom-hooks/useDebounce";

import { isEmpty, isEqual } from "lodash";

// const getTabQueryKey = (tabType, id) => `${tabType}_${id}`;

const searchQueryWidget = t => ({
    key: "query",
    widgetType: "input",
    title: t("Search"),
    id: "query",
    placeholder: "SEARCH",
    type: "STRING",
})

const ADDITIONAL_WIDGETS_MAP = (t, tabName) => {
    switch (tabName) {
        case "appeals": {
            return [searchQueryWidget(t)];
        }
        case "tasks": {
            return [searchQueryWidget(t)];
        }
        case "services": {
            return [searchQueryWidget(t)];
        }
        case "resources": {
            return [searchQueryWidget(t)];
        }
        case "documents": {
            return [searchQueryWidget(t)];
        }
        default: {
            return [searchQueryWidget(t)];
        }
    }
};

const FILTERS_OPEN_STATIC_WIDTH = 260;
const FILTERS_COLLAPSED_STATIC_WIDTH = 40;


const mapStateToProps = (state, ownProps) => {
    let filtersStoreKey = ownProps.itemId
        ? `customer-filters-${ownProps.code}-${ownProps.itemType}-${ownProps.itemId}-${ownProps.customerId}`
        : `customer-filters-${ownProps.code}-${ownProps.customerId}`;
    if (ownProps.contactPersonId) {
        filtersStoreKey = `${filtersStoreKey}-${ownProps.contactPersonId}`;
    }
    if (ownProps.tabNum) {
        form = `${filtersStoreKey}_${ownProps.tabNum}`;
    }

    const attributesFilters = state.attributesFilters[filtersStoreKey];

    return {
        grids: state.grid,
        attributes: attributesFilters && attributesFilters.attributes,
        isFiltersOpen:
            attributesFilters && ![null, undefined].includes(attributesFilters.isOpen)
                ? attributesFilters.isOpen
                : true,
        filterFormValues: getFormValues(`${filtersStoreKey}-filters-main`)(state),
        filterFormErrors: getFormSyncErrors(`${filtersStoreKey}-filters-main`)(state),
        filtersStoreKey,
        // currentTabs: state.tabs && state.tabs.tabs,
    };
};

const ListWithFilter = props => {
    const {
        t,
        gridUrlKey = "customer_grid_with_filters",
        history,
        updateApiGrid,
        itemId,
        itemType,
        code,
        // match: {
        //     params: { id: customerId },
        // },
        fixedFilterObject = [], // was implemented within SDSUI-7535 (some static param from tab config)
        initSort,
        gridConfigCode,
        tabNum,
        gridCustomType,
        gridCustomCode,
        gridType,
        gridConfigKey,
        grids,
        onGridExport,
        customerId,
        contactPersonId,
        historyPath,
        onGridFloatingButtonClick,
        filtersStoreKey,
        filterFormValues,
        attributes,
        isFiltersOpen,
        // currentTabs
    } = props;


    const { debouncedValue: debouncedFilterFormValues, setDebouncedValue: setDebouncedFilterFormValues } = useDebounce(
        filterFormValues,
        300
    );

    const tabName = props.match.params.subTab;
    const TYPE = gridCustomType || code.toUpperCase();
    const CODE = gridConfigCode || `CUSTOMER_${TYPE}_TAB`;

    const OBJECT_TYPE = gridCustomCode || TYPE;

    const [loadingState, setLoadingState] = useState(true);
    const [gridFilters, setGridFilters] = useState({});


    const init = {
        method: "post",
        key: gridUrlKey,
        code: CODE,
        type: gridType,
        pathParams: { customerId, objectType: OBJECT_TYPE, contactPersonId },
        extra: itemId ? `${TYPE}_${itemType}_${itemId}.${customerId}` : `${TYPE}_${customerId}`,
        ...gridFilters,
        configUrlKey: "config_grid",
        configKey: gridConfigKey || gridType,
        configCode: gridConfigCode || gridCustomCode ||  TYPE,
    };
    if (tabNum) {
        init.extra = `${init.extra}_${tabNum}`;
    }
    if (contactPersonId) {
        init.extra = `${init.extra}_${contactPersonId}`;
    }
    if (initSort && initSort[0]) {
        init.sort = initSort;
        init.field = initSort[0].property;
        init.order = initSort[0].direction;
    }

    const gridKey = `${init.key}_${init.path || init.extra || ""}`;

    const getParams = () => ({
        selectItem: item => {
            // const type = historyPath || code;
            // const tabQueryKey = getTabQueryKey(type, item.id);
            // const existingTab = currentTabs.find(tab => tab.queryKey.startsWith(tabQueryKey));
            // // we need to find a main breadcrumb on customer page since if customer crumb is active - then tab url is the same (customer url)
            // const mainBreadCrumb =
            //     existingTab && existingTab.breadcrumbs.find(breadcrumb => breadcrumb.type === "main");
            // const urlToPush =
            //     mainBreadCrumb && mainBreadCrumb.subTab
            //         ? `/${type}/${item.id}/${mainBreadCrumb.subTab}`
            //         : `/${type}/${item.id}`;
            // history.push(urlToPush);
            history.push(`/${historyPath || code}/${item.id}`);
        },
        fields: {
            hasFlow: {
                component: Diagram,
            },
        },
    });

    const onStart = () => setLoadingState(true);

    const onFinish = () => setLoadingState(false);

    function handleGridExport() {
        onGridExport(grids[gridKey])
    }

    useEffect(() => {
        customerId && !isEmpty(gridFilters) &&
            updateApiGrid(
                {
                    pathParams: { customerId, objectType: OBJECT_TYPE, contactPersonId },
                    ...gridFilters,
                },
                gridKey
            );

    }, [customerId, gridFilters]);

    useEffect(() => {
        if (!isEmpty(debouncedFilterFormValues)) {
            const { query: formQuery, ...rest} = debouncedFilterFormValues;
            const query = formQuery || "";
            const filterObject = configureFilterObject(rest, attributes || []);
            const isQueryDiff = query !== gridFilters.query;
            const isFilterDiff = !isEqual(filterObject, gridFilters.filterObject);
            if (isQueryDiff || isFilterDiff) {
                setGridFilters({query, filterObject: [...filterObject, ...fixedFilterObject]});
            }
        }
    }, [debouncedFilterFormValues, attributes]);


    return (
        <div className="content-wrapper-with-filters ordering-component-ui-core-wrapper">
            <div className={cx('content-wrapper with-fixed-status', {'filters-open': isFiltersOpen})}>
                {loadingState && <Loader />}
                {!isEmpty(gridFilters) && (
                    <GridWrapper
                        tuner={() => init}
                        initUpdate={false}
                        gridParams={getParams()}
                        onStart={onStart}
                        onFinish={onFinish}
                        onGridExport={onGridExport && handleGridExport}
                        fieldsLsCacheKey={`customer_page_${gridConfigKey || gridType}`}
                        sortFieldsLsCacheKey={`customer_page_${gridKey}`}
                        onGridFloatingButtonClick={onGridFloatingButtonClick}
                        floatingButtonLeftOffset={isFiltersOpen ? FILTERS_OPEN_STATIC_WIDTH : FILTERS_COLLAPSED_STATIC_WIDTH}
                    />
                )}
            </div>
            {customerId && (
                <AttributesFiltersForm
                    // storeKey={filtersStoreKey}
                    storeKey={filtersStoreKey}
                    // extraFormKey={`${FILTERS_CODE_MAP[tabName]}-${customerId}`}
                    attributesRequestKey={"attributes"}
                    attributesRequestParams={{ customer: customerId, person: contactPersonId, code: CODE }}
                    // filtersCode={"customer"} // used for filters list
                    attributesValuesRequestKey={"info_filter"}
                    attributesValuesRequestParams={{ code: CODE }}
                    isKeepOnUnmount
                    withoutSave
                    withHeaderForm={false}
                    additionalWidgets={ADDITIONAL_WIDGETS_MAP(t, tabName)}
                    withToggle
                    key={filtersStoreKey}
                />
            )}
        </div>
    );
};

export default connect(mapStateToProps, { updateApiGrid: setApi })(withRouter(withTranslation()(ListWithFilter)));
